// extracted by mini-css-extract-plugin
export default {"tags":"tags_tags__S7dOe","tags__item":"tags_tags__item__pWt9a"};